/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Amex/view.blocks to change it.
import CreditCardAmex from 'DesignSystem/Svgs/CreditCardAmex/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Amex({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Card/CardBrand/Amex"
  
}) {
  return (<React.Fragment
>
<CreditCardAmex
  viewPath={`${viewPath}/CreditCardAmex`}
 width={35}
 marginTop="auto"
 marginBottom="auto"
/>
{children}
</React.Fragment>)
}